import { Box, Typography, Theme, SxProps, Fade } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { useMemo } from 'react';

const styleSubtitlesContainer = {
    display: 'flex',
    justifyContent: 'center',
};

const styleSubtitles = {
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light'
            ? theme.palette.mask.white['60p']
            : theme.palette.mask.black['60p'],
    borderRadius: 2,
    py: 1,
    px: 2,
    maxWidth: { xs: '90vw', sm: '90vw', md: '80vw', lg: '70vw', xl: '60vw' },
};

interface MediaSubtitlesProps {
    sx?: SxProps<Theme>;
    cue?: VTTCue;
    isMuted?: boolean;
    fadeIn?: boolean;
}
export function MediaSubtitles({
    cue,
    isMuted,
    sx,
    fadeIn,
}: MediaSubtitlesProps) {
    const component = useMemo(
        () => (
            <Box sx={sxAppend(styleSubtitlesContainer, sx)}>
                <Typography
                    variant="body1"
                    sx={styleSubtitles}
                    color="text.body"
                    textAlign="center"
                    role="alert"
                    aria-live="polite"
                    aria-hidden={!isMuted}
                >
                    {cue?.text}
                </Typography>
            </Box>
        ),
        [cue?.text, isMuted, sx]
    );

    if (!cue?.text) {
        return null;
    }

    return typeof fadeIn === 'boolean' ? (
        <Fade
            in={fadeIn}
            timeout={{ enter: 500, exit: 0 }}
            mountOnEnter
            unmountOnExit
        >
            {component}
        </Fade>
    ) : (
        component
    );
}
